import { createAction, props } from '@ngrx/store';
import { ILoaderActionPayload } from '../models/loader.model';
import {
  EmailReportRuleControllerCreate$Params,
  EmailReportRuleControllerDelete$Params,
  EmailReportRuleControllerFind$Params,
  EmailReportRuleControllerFindOne$Params,
  EmailReportRuleControllerUpdate$Params,
  EmailReportRuleControllerSendNow$Params,
} from '../../../api/functions';
import { EmailReportRuleItem, EmailReportRuleListResponse } from '../../../api/models';

export const emailReportRuleActions = {
  // find list
  find: createAction('email-report-rule/find', props<EmailReportRuleControllerFind$Params>()),
  findDone: createAction(
    'email-report-rule/find/done',
    props<{
      state: ILoaderActionPayload;
      data?: EmailReportRuleListResponse;
      request?: EmailReportRuleControllerFind$Params;
    }>(),
  ),
  findSetState: createAction('email-report-rule/find/state', props<{ state: ILoaderActionPayload }>()),

  // find one
  findOne: createAction('email-report-rule/find-one', props<EmailReportRuleControllerFindOne$Params>()),
  findOneDone: createAction(
    'email-report-rule/find-one/done',
    props<{ state: ILoaderActionPayload; data?: EmailReportRuleItem }>(),
  ),
  findOneSetState: createAction('email-report-rule/find-one/state', props<{ state: ILoaderActionPayload }>()),

  // create
  create: createAction('email-report-rule/create', props<EmailReportRuleControllerCreate$Params>()),
  createDone: createAction(
    'email-report-rule/create/done',
    props<{
      state: ILoaderActionPayload;
      data?: EmailReportRuleItem;
      request?: EmailReportRuleControllerCreate$Params;
    }>(),
  ),
  createSetState: createAction('email-report-rule/create/state', props<{ state: ILoaderActionPayload }>()),

  // update
  update: createAction('email-report-rule/update', props<EmailReportRuleControllerUpdate$Params>()),
  updateDone: createAction(
    'email-report-rule/update/done',
    props<{
      state: ILoaderActionPayload;
      data?: EmailReportRuleItem;
      request?: EmailReportRuleControllerUpdate$Params;
    }>(),
  ),
  updateSetState: createAction('email-report-rule/update/state', props<{ state: ILoaderActionPayload }>()),

  // delete
  deleteRule: createAction('email-report-rule/delete', props<EmailReportRuleControllerDelete$Params>()),
  deleteRuleDone: createAction(
    'email-report-rule/delete/done',
    props<{ state: ILoaderActionPayload; data?: EmailReportRuleItem }>(),
  ),
  deleteRuleSetState: createAction('email-report-rule/delete/state', props<{ state: ILoaderActionPayload }>()),

  // send now
  sendNow: createAction('email-report-rule/send-now', props<EmailReportRuleControllerSendNow$Params>()),
  sendNowDone: createAction('email-report-rule/send-now/done', props<{ state: ILoaderActionPayload }>()),
  sendNowSetState: createAction('email-report-rule/send-now/state', props<{ state: ILoaderActionPayload }>()),
};
